import { ChevronRight } from '@hhgtech/icons/arrow'
import { Box } from '@mantine/core'
import cls from 'classnames'

const ControlNext = ({
  canScrollNext,
  onClick,
}: {
  canScrollNext: boolean
  onClick: () => void
}) => {
  return (
    <Box
      className={cls('flex w-12 h-10 absolute right-0 top-0 transition-all', {
        'opacity-0 pointer-events-none': !canScrollNext,
      })}
    >
      <Box
        className="w-6"
        style={{
          background:
            'linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%)',
        }}
      />
      <Box className="w-6 bg-white py-2 cursor-pointer" onClick={onClick}>
        <ChevronRight size={24} />
      </Box>
    </Box>
  )
}

export default ControlNext
